<script lang="ts">
  import { mloc } from "module/utils";
  import { fakeSearchResults } from "module/fakeSearchData";
  import { ModuleSetting } from "module/store/ModuleSettings";
  import { stores } from "module/store/SettingsStore";

  import FormCheckbox from "./forms/FormCheckbox.svelte";
  import FormSelect from "./forms/FormSelect.svelte";
  import SettingsGroup from "./SettingsGroup.svelte";
  import ExampleResults from "./ExampleResults.svelte";

  let { active = false } = $props();

  const insertResults = fakeSearchResults(true);

  let defaultActionMacro = stores[ModuleSetting.DEFAULT_ACTION_MACRO];
  let defaultActionRollTable = stores[ModuleSetting.DEFAULT_ACTION_ROLL_TABLE];
  let defaultActionScene = stores[ModuleSetting.DEFAULT_ACTION_SCENE];

  let browseResults = $derived(
    $defaultActionMacro &&
      $defaultActionRollTable &&
      $defaultActionScene &&
      fakeSearchResults()
  );
</script>

<div class="usertab standard-form" class:hidden={!active} role="tabpanel">
  <p class="notes">
    {mloc("SettingsUserSettingDescription")}
  </p>
  <SettingsGroup title="General Settings">
    <div class="options">
      <FormSelect
        label={mloc("SettingsSearchDensity")}
        setting={ModuleSetting.SEARCH_DENSITY}
        notes={mloc("SettingsSearchDensityHint")}
      />
      <FormCheckbox
        label={mloc("SettingsSearchFooter")}
        setting={ModuleSetting.SEARCH_FOOTER}
        notes={mloc("SettingsSearchFooterHint")}
      />
      <FormSelect
        label={mloc("SettingsSearchTooltips")}
        setting={ModuleSetting.SEARCH_TOOLTIPS}
        notes={mloc("SettingsSearchTooltipsHint")}
      />
      <FormCheckbox
        label={mloc("SettingsEnhancedTooltips")}
        setting={ModuleSetting.ENHANCED_TOOLTIPS}
        notes={mloc("SettingsEnhancedTooltipsHint")}
      />
      <FormSelect
        label={mloc("SettingsSearchEngine")}
        setting={ModuleSetting.SEARCH_ENGINE}
        notes={mloc("SettingsSearchEngineHint")}
      />
      <FormCheckbox
        label={mloc("SettingsQuickFilterEdit")}
        setting={ModuleSetting.QUICK_FILTER_EDIT}
        notes={mloc("SettingsQuickFilterEditHint")}
      />
    </div>
  </SettingsGroup>

  <SettingsGroup title={mloc("ModeBrowse")}>
    <p class="notes">
      {@html mloc("ModeBrowseDescription")}
    </p>

    <div class="options">
      <FormCheckbox
        label={mloc("SettingsEnableGlobalContext")}
        setting={ModuleSetting.ENABLE_GLOBAL_CONTEXT}
        notes={mloc("SettingsEnableGlobalContextHint")}
      />
      <FormCheckbox
        label={mloc("SettingsRememberBrowseInput")}
        setting={ModuleSetting.REMEMBER_BROWSE_INPUT}
        notes={mloc("SettingsRememberBrowseInputHint")}
      />
      <legend>{mloc("SettingsDefaultActionCategory")}</legend>
      <p class="notes">
        {@html mloc("SettingsDefaultActionDescription")}
      </p>
      <FormSelect
        sub
        label="Scenes"
        setting={ModuleSetting.DEFAULT_ACTION_SCENE}
      />
      <FormSelect
        sub
        label="Rollable Tables"
        setting={ModuleSetting.DEFAULT_ACTION_ROLL_TABLE}
      />
      <FormSelect
        sub
        label="Macros"
        setting={ModuleSetting.DEFAULT_ACTION_MACRO}
      />
    </div>
    <ExampleResults results={browseResults || []}>
      {@html mloc("SettingsExampleBrowse")}
    </ExampleResults>
  </SettingsGroup>
  <SettingsGroup title={mloc("ModeInsert")}>
    <div class="options">
      <p class="notes">
        {@html mloc("ModeInsertDescription")}
      </p>
    </div>
    <ExampleResults results={insertResults}>
      {@html mloc("SettingsExampleInsert")}
    </ExampleResults>
  </SettingsGroup>
</div>

<style>
  .usertab {
    overflow: auto;
    height: 100%;
    padding: 0.6em;
  }

  .hidden {
    display: none;
  }

  .usertab :global(.form-fields:first-child) {
    flex-grow: 0;
    margin-right: 0.2em;
  }

  .options {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    width: 50%;
    gap: 1rem;
  }
  h3 {
    margin: 0 !important;
    color: var(--color-text-primary);
    text-shadow: none;
  }

  p.notes {
    margin-top: 0;
  }

  :global(kbd) {
    flex: none;
    padding: 0 4px;
    min-width: 24px;
    background: rgba(255, 255, 255, 0.25);
    border: 1px solid var(--color-border-light-2);
    border-radius: 5px;
    box-shadow: 1px 1px #444;
    text-align: center;
  }
</style>
